import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FontIcon from "@odl/core/components/DataDisplay/FontIcon";
import CircularProgress from "@mui/material/CircularProgress";
import Guard from "components/Guard/Guard";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";

type Props = {
  statusLabel: string;
  isLoading?: boolean;
};

const ProcessingStatusLabel: React.FC<Props> = ({ statusLabel, isLoading = false }) => {
  return (
    <StyledListItem>
      <ListItemIcon>
        <Guard condition={isLoading} fallback={<StyledFontIcon name={"i-status-checkmark-filled"} />}>
          <StyledCircularProgress />
        </Guard>
      </ListItemIcon>
      <StyledListItemText primary={statusLabel} />
    </StyledListItem>
  );
};

const StyledListItem = styled(ListItem)(
  ({ theme }) => css`
    padding: 6px 16px;
    background: #e0f3ff80;
    box-shadow: none;
    ${theme.mixins.flexGap("16px")}
  `
);

const StyledListItemText = styled(ListItemText)(
  ({ theme }) => css`
    margin: 0;
    color: ${theme.palette.text.secondary};
  `
);

const StyledFontIcon = styled(FontIcon)(
  ({ theme }) => css`
    width: 21px;
    height: 21px;
    font-size: 21px;
    color: ${theme.palette.objective.green.main};
  `
);

const StyledCircularProgress = styled(CircularProgress)(
  ({ theme }) => css`
    width: 21px !important;
    height: 21px !important;
    padding: 1px;
  `
);

export default ProcessingStatusLabel;
